/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

/* Custom */
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';

export const FETCH_COMMITS = 'FETCH_COMMITS';
export const FETCH_COMMITS_SUCCESS = 'FETCH_COMMITS_SUCCESS';
export const FETCH_COMMITS_ERROR = 'FETCH_COMMITS_ERROR';

export const FETCH_BRANCHES = 'FETCH_BRANCHES';
export const FETCH_BRANCHES_SUCCESS = 'FETCH_BRANCHES_SUCCESS';
export const FETCH_BRANCHES_ERROR = 'FETCH_BRANCHES_ERROR';

export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_ERROR = 'FETCH_PROJECTS_ERROR';
export const SET_PROJECT = 'SET_PROJECT';


export const FETCH_PIPELINES = 'FETCH_PIPELINES';
export const FETCH_PIPELINES_SUCCESS = 'FETCH_PIPELINES_SUCCESS';
export const FETCH_PIPELINES_ERROR = 'FETCH_PIPELINES_ERROR';

export const FETCH_HOSTS = 'FETCH_HOSTS';
export const FETCH_HOSTS_SUCCESS = 'FETCH_HOSTS_SUCCESS';
export const FETCH_HOSTS_ERROR = 'FETCH_HOSTS_ERROR';

export const FETCH_ACTIONLOGS = 'FETCH_ACTIONLOGS';
export const FETCH_ACTIONLOGS_SUCCESS = 'FETCH_ACTIONLOGS_SUCCESS';
export const FETCH_ACTIONLOGS_ERROR = 'FETCH_ACTIONLOGS_ERROR';

export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_ERROR = 'FETCH_CUSTOMERS_ERROR';

export const FETCH_LICENSES = 'FETCH_LICENSES';
export const FETCH_LICENSES_SUCCESS = 'FETCH_LICENSES_SUCCESS';
export const FETCH_LICENSES_ERROR = 'FETCH_LICENSES_ERROR';

export const FETCH_ITPARTNER = 'FETCH_ITPARTNER';
export const FETCH_ITPARTNER_SUCCESS = 'FETCH_ITPARTNER_SUCCESS';
export const FETCH_ITPARTNER_ERROR = 'FETCH_ITPARTNER_ERROR';

/* SMARTOFFICE APP */
export const SMARTOFFICE_GET_CONTACTS = "SMARTOFFICE_GET_CONTACTS";
export const SMARTOFFICE_GET_CONTACTS_SUCCESS = "SMARTOFFICE_GET_CONTACTS_SUCCESS";
export const SMARTOFFICE_GET_CONTACTS_ERROR = "SMARTOFFICE_GET_CONTACTS_ERROR";
export const SMARTOFFICE_GET_CONVERSATIONS = "SMARTOFFICE_GET_CONVERSATIONS";
export const SMARTOFFICE_GET_CONVERSATIONS_SUCCESS = "SMARTOFFICE_GET_CONVERSATIONS_SUCCESS";
export const SMARTOFFICE_GET_CONVERSATIONS_ERROR = "SMARTOFFICE_GET_CONVERSATIONS_ERROR";
export const REMOVE_RECORDING_PATH = "REMOVE_RECORDING_PATH";

/* TRAIN */
export const FETCH_INTENTS = "FETCH_INTENTS";
export const FETCH_INTENTS_SUCCESS = "FETCH_INTENTS_SUCCESS";
export const FETCH_INTENTS_ERROR = "FETCH_INTENTS_ERROR";
export const TRAIN_SELECT_INTENT = "TRAIN_SELECTED_INTENT";
export const TRAIN_SET_SELECTED_MESSAGE = "TRAIN_SET_SELECTED_MESSAGE";
export const TRAIN_CLEAR = "TRAIN_CLEAR";
export const TRAIN_CLEAR_INTENT_SELECTION = "TRAIN_CLEAR_INTENT_SELECTION";

export * from "./menu/actions";
export * from "./settings/actions";
export * from "./auth/actions";
export * from "./smartoffice/actions";
